import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 30000,
});

export const healthApi = {
  getHealth: () => api.get('/health'),
};

export const authApi = {
  getToken: () => api.get('/auth/token'),
};

export const predictionApi = {
  predict: (data) => api.post('/ask-pdf', data),
  followUp: (data) => api.post('/ask-pdf-followup', data),
};

export const pdfApi = {
  downloadPDFs: (data) => api.post('/download-pdfs', data),
  getStatus: (params) => api.get('/pdf-status', { params }),
  list: (params) => api.get('/list-pdfs', { params }),
};

export const productRAGApi = {
  query: (data) => api.post('/product-rag', data),
  search: (params) => api.get('/product-rag/search', { params }),
  update: (data) => api.put('/product-rag', data),
};

export default api;
